export default {
  formData: [],
  formName: "",
  formEditMode: false
};
